<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Registratură Online - Direcția Generală de Impozite și Taxe Locale
            </h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <!-- Redirect botton for showing slug data in a separate page -->
    <!-- <button style="border-radius: 4px;padding: 4px 6px; color:red; margin: 3px 0; border:0; "
    (click)="redirectTo()">Redirect</button> -->
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă cereri</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('dgitl-module.cerere.add')" type="button"
                                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <br />
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Categorie cerere</mat-label>
                                        <mat-select formControlName="id_category"
                                            (openedChange)="onDepartamentSelectClosed()"
                                            (selectionChange)="onDepartamentChange($event.value)">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="categoriiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredCategorii.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let departament of filteredCategorii"
                                                [value]="departament.id_compartiment">
                                                {{ departament.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Tip problemă</mat-label>
                                        <mat-select (openedChange)="onTipSelectClosed()"
                                            formControlName="id_cerere_type">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="tipuriProblemaControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredTipuriProblema.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let tip of filteredTipuriProblema" [value]="tip.id">
                                                {{ tip.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Număr cerere</mat-label>
                                        <input matInput type="number" formControlName="reg_numar" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Număr cerere (intern)</mat-label>
                                        <input matInput type="number" formControlName="id_cerere" />
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Cetățean</mat-label>
                                        <input matInput type="text" formControlName="nume_cetatean" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>CNP/CUI</mat-label>
                                        <input matInput type="number" formControlName="cnp_cetatean" />
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Email</mat-label>
                                        <input matInput type="text" formControlName="email_cetatean" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Stadiu Cerere</mat-label>
                                        <mat-select formControlName="validated">
                                            <mat-option *ngFor="let option of statusParameters" [value]="option.value">
                                                {{ option.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Categorie curentă cerere</mat-label>
                                        <mat-select (openedChange)="onCategorieCurentSelectClosed()"
                                            (selectionChange)="onCategorieCurentChange($event.value)"
                                            formControlName="current_cerere_id_compartiment">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="categoriiCurentControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredCategoriiCurent.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let departament of filteredCategoriiCurent"
                                                [value]="departament.id_compartiment">
                                                {{ departament.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Responsabil</mat-label>
                                        <mat-select (openedChange)="onUsersSelectClosed()"
                                            formControlName="responsible_id">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="usersControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                                {{ user.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Responsabil Cerere</mat-label>
                                        <mat-select formControlName="assignee_id">
                                            <mat-option *ngFor="let option of responsabilCerereParameters"
                                                [value]="option.value">
                                                {{ option.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Serie Șasiu</mat-label>
                                        <input matInput type="text" formControlName="serie_sasiu" />
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Marca auto</mat-label>
                                        <input matInput type="text" formControlName="marca" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Sursă Cerere</mat-label>
                                        <mat-select formControlName="source">
                                            <mat-option *ngFor="let option of sourceParameters" [value]="option.id">
                                                {{ option.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button d-flex align-items-center" (click)="toggleCard()"
                                [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                            <button class="action-button d-flex align-items-center" (click)="rerenderDT(true)">
                                <i class="fa-solid fa-search me-2"></i>
                                <span>Caută</span>
                            </button>
                            <ng-container *ngIf="checkboxSelections">
                                <button *ngIf="permissionsService.hasPermission('dgitl-module.cerere.mass-assign')"
                                    class="action-button d-flex align-items-center" (click)="openReassignComponent()">
                                    <span>Asignează</span>
                                </button>
                                <button
                                    *ngIf="permissionsService.hasPermission('dgitl-module.cerere.mass-update-status')"
                                    class="action-button d-flex align-items-center"
                                    (click)="openChangeStatusComponent()">
                                    <span>Schimbare Status</span>
                                </button>
                                <button
                                    *ngIf="permissionsService.hasPermission('dgitl-module.cerere.mass-update-priority')"
                                    class="action-button d-flex align-items-center"
                                    (click)="openChangePrioritateComponent()">
                                    <span>Actualizare Prioritate</span>
                                </button>
                                <button
                                    *ngIf="permissionsService.hasPermission('dgitl-module.cerere.mass-close') && 
                                    this.searchParamsForm.get('id_category')?.value !== -1 && 
                                    this.searchParamsForm.get('id_cerere_type')?.value !== -1 && 
                                    (this.searchParamsForm.get('cnp_cetatean')?.value !== '' && this.searchParamsForm.get('cnp_cetatean')?.value !== null)"
                                    class="action-button d-flex align-items-center"
                                    (click)="openInchidereMultiplaComponent()">
                                    <span>Închidere multiplă cereri</span>
                                </button>
                            </ng-container>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <mat-chip-listbox *ngIf="notificationParameter.name" aria-label="Notification selection">
                                <mat-chip-option>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <span style="margin-left: 3px;" (click)="removeChip()" aria-label="Remove">
                                            <mat-icon>cancel</mat-icon>
                                        </span>
                                    </div>
                                </mat-chip-option>
                            </mat-chip-listbox>
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <!-- <mat-form-field class="w-100">
                                                <mat-label>Filtrare după</mat-label>
                                                <mat-select [(ngModel)]="dateFilterOption">
                                                  <mat-option
                                                    *ngFor="let value of dateFilteringOptions"
                                                    [value]="value"
                                                  >
                                                    {{ value }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field> -->
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PÂNĂ LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="request-filter-container">
                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusCerere" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onCategoryChange($event)" [value]="selectedCategory">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>